module.exports = __webpack_public_path__ + "static/media/Avatars_Other-24.9e10824e.png";